module.exports = __webpack_public_path__ + "img/CwLogo.89e7204b.svg";